import { JSX } from 'preact';

interface ChorusEmptyProps {
  size?: number;
  variant?: 'aligned' | 'dispersed';
}

const FILLS = ['var(--st-author-1)', 'var(--st-author-2)', 'var(--st-author-4)', 'var(--st-author-3)'];

export function ChorusEmpty({ size = 120, variant = 'aligned' }: ChorusEmptyProps): JSX.Element {
  const dispersed = variant === 'dispersed';
  const positions = dispersed
    ? [
        { cx: 25, cy: 30, r: 22 },
        { cx: 95, cy: 25, r: 18 },
        { cx: 90, cy: 90, r: 20 },
        { cx: 30, cy: 95, r: 19 },
      ]
    : [
        { cx: 45, cy: 55, r: 32 },
        { cx: 90, cy: 45, r: 26 },
        { cx: 75, cy: 80, r: 28 },
      ];

  return (
    <svg width={size} height={size} viewBox="0 0 120 120" aria-hidden="true">
      {positions.map((p, i) => (
        <circle
          key={i}
          cx={p.cx}
          cy={p.cy}
          r={p.r}
          fill={FILLS[i % FILLS.length]}
          opacity={dispersed ? 0.35 : 0.5}
          style={{ mixBlendMode: 'multiply' }}
        />
      ))}
    </svg>
  );
}
